import { getWalletData, stringToElements } from '../helpers/index.js';
import { getOpenWalletLink } from './links.js';

// This is not currently used. It was a quick test of adding a loading
// indicator in places where Wallet content is about to be rendered.
// It could be used with a little bit of work to smooth out the transitions.
// There is CSS for this also. Search for: getLoadingIndicatorCSS
export const getLoadingIndicatorMarkup = () => {
	const childDivs = '<div class="one"></div><div class="two"></div><div class="three"></div><div class="four"></div>';
	return stringToElements(`<div class="lds-ellipsis" data-web-api-inserted="true">${childDivs}</div>`);
}

export const getPricingFacetMarkup = async (config) => {
	const {
		enterAmount,
		example,
		maxPayment,
		updatePaymentSettings,
		defaultMonthlyBudget
	} = config;

	const monthlyBudget = await getWalletData('monthlyBudget');
	const hasMonthlyBudget = (monthlyBudget && monthlyBudget > 0);
	const exampleMarkup = hasMonthlyBudget ? '' : `<span class="ddc-font-size-xsmall text-muted">${example}</span> `;
	const displayedPayment = hasMonthlyBudget ? monthlyBudget : defaultMonthlyBudget;
    const ddcSiteDesign = window?.DDC?.dataLayer?.site?.design;
	const isLincoln = ddcSiteDesign?.themekit === 'LIGHT-ORANGE_WHITE' && ddcSiteDesign?.variationId === 'v9_OEM_LINCOLN_0002_V1';
	// We need to add this condition just for lincoln because bg-contrast-med color is little off for this variation
	// and pricing facet does not looks good so need to fix this for this variationa nd theme.
	const bgContrastClsForPricingFacet = isLincoln ? 'bg-contrast-low' : 'bg-contrast-med';
	
	const pricingFacetTemplate = `
		<div class="box box-border align-center p-4 border border-radius-sm ${bgContrastClsForPricingFacet}">
			<p class="ddc-font-size-small"><span class="mywallet-icon"></span><strong>My Wallet</strong></p>
			<p class="ddc-font-size-xsmall text-muted line-height-reset m-3">${maxPayment}</p>
			<p class="line-height-reset m-3">${exampleMarkup}
				<span class="ddc-font-size-small"><strong>$${displayedPayment}</strong></span><span class="ddc-font-size-xsmall text-muted"> / mo</span>
			</p>
			<p class="line-height-reset m-3 wallet-link"></p>
		</div>
	`;

	const markup = stringToElements(pricingFacetTemplate);

	const paymentLinkLabel = hasMonthlyBudget ? updatePaymentSettings : enterAmount;

	const paymentLinkClasses = hasMonthlyBudget ? 'ddc-font-size-xsmall text-link-muted' : 'ddc-font-size-small text-link';
	const openWalletLink = getOpenWalletLink(paymentLinkLabel, paymentLinkClasses, false, false, null, 'budget');

	// We add the link after constructing the markup template
	// so that we don't lose the click handler on the link.
	markup.querySelector('.wallet-link').appendChild(openWalletLink);

	return markup;
}

export const getLinkMarkup = (openWalletLink, openCreditAppLink, isNewComparePage) => {
	const markup = stringToElements(`<p class="${isNewComparePage ? 'text-center' : 'text-right'}"><span class="wallet-link"></span></p>`);
	// We add the link after constructing the markup template
	// so that we don't lose the click handler on the link.
	const walletLinks = markup.querySelector('.wallet-link');
	walletLinks.appendChild(openWalletLink);

	if(openCreditAppLink && !isNewComparePage) {
		walletLinks.appendChild(openCreditAppLink);
	}

	return markup;
}

export const getCreditAppNoPaymentLink = (openCreditAppLink) => {
	const markup = stringToElements('<p class="text-right"><span></span></p>');
	markup.appendChild(openCreditAppLink);
	return markup;
}

export const getPaymentMarkup = (
	singleLine, 
	payment, 
	frequency, 
	disclaimer, 
	openWalletLink, 
	openCreditAppLink, 
	isMobile, 
	isNewCarBoostPayment, 
	newCarBoostPaymentLabel, 
	isSRP, 
	isNewComparePage
) => {
	let popoverMarkupStart = '';
	let popoverMarkupEnd = '';
	let paymentMarkup = '';
	let spacing = '';
	let paymentFontSize = '';

	paymentFontSize = isSRP && isMobile ? 'ddc-font-size-small' : '';

	if (payment && frequency) {
		spacing = singleLine ? '&nbsp;&nbsp;' : '<br />';
		if (disclaimer) {
			popoverMarkupStart = `<span class="togglePopover" data-toggle="popover" 
				data-container="body" data-placement="left" data-content="${disclaimer}" 
				data-original-title="" title="">`;
			popoverMarkupEnd = '</span>';
		}
		if (isNewCarBoostPayment) {
			paymentMarkup = '<span class="price-value font-weight-bold text-discount ddc-font-size-large">' +
				`$${Math.floor(payment)}</span><span class="text-muted font-weight-normal"> / ${frequency}</span>`;
		}
		else if (isNewComparePage){
			paymentMarkup = '<span class="price-value font-weight-bold ddc-font-size-large">' + 
				`$${Math.floor(payment)}</span><span class="text-muted ddc-font-size-xsmall"> / ${frequency}</span>`;
		}
		else {
			paymentMarkup = `<span class="price-value font-weight-bold ${paymentFontSize}">` +
				`$${Math.floor(payment)}</span><span class="text-muted"> / ${frequency}</span>`;
		}
		
	}

	// VDP mobile requires this
	const paddingClass = isMobile && !isSRP ? 'px-5' : '';

	let markup = '';
	if (isNewCarBoostPayment) {
		markup = stringToElements(
			'<div style="background-color:var(--color-neutral-1000-alpha-05);" ' +
			'class="d-block text-left p-3 border-radius-sm font-weight-normal float-none">' +
			`<p class="ddc-font-size-xsmall">${newCarBoostPaymentLabel}</p>` +
			`<p>${popoverMarkupStart}${paymentMarkup}${popoverMarkupEnd}&nbsp;&nbsp;` +
			'<span class="wallet-link"></span></p></div>'
		);
	} 
	else if (isNewComparePage){
		markup = stringToElements(
			`<p class="text-right d-flex align-items-end justify-content-center ${paddingClass}">` +
			`${popoverMarkupStart}${paymentMarkup}${popoverMarkupEnd}` +
			'<span class="wallet-link ml-3"></span></p>'
		);
	}
	else {
		markup = stringToElements(
			`<p class="text-right ${paddingClass}">` +
			`${popoverMarkupStart}${paymentMarkup}${popoverMarkupEnd}${spacing}` +
			'<span class="wallet-link"></span></p>'
		);
	}

	// We add the link after constructing the markup template
	// so that we don't lose the click handler on the link.
	const walletLinks = markup.querySelector('.wallet-link');

	walletLinks.appendChild(openWalletLink);
	if (openCreditAppLink && !isNewComparePage) {
		walletLinks.appendChild(openCreditAppLink);
	}

	return markup;
}
